<template>
	<div class="indexmain">
		<!-- <div class="h68 bg-header"></div> -->
		<el-image src="../../../static/images/index_main-bg.jpg" class="image" fit="cover"></el-image>
	</div>
</template>

<script>
	// import bus from '@/assets/js/bus';
	import './index.less'
	export default {
		name: 'index',
		data() {
			return {

			}
		},
		methods: {},
		components: {

		},
		created() {
			//路由实例对象
			//console.log(this.$router);
			//路由信息对象
			// console.log(this.$route);

		},
		mounted() {

			// window.removeEventListener('scroll', this.onScroll);
		}
	}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/index/index.vue